import { cn } from "@sagot/ui";

/** "or" / "or sign up with" rule between form sections. */
export function AuthDivider({ label, className }: { label: string; className?: string }) {
  return (
    <div className={cn("my-6 flex items-center gap-3 text-xs font-semibold text-fg-subtle", className)}>
      <span className="divider flex-1" />
      {label}
      <span className="divider flex-1" />
    </div>
  );
}
